<div class="nav-list login-button-wrap list-unstyled p-0 m-0">
  <a routerLink="/login" class="user-wrapper pl-2 pr-2 d-flex flex-column flex-lg-row align-items-lg-center">
    <i class="fa-regular fa-user mx-lg-2"></i>
    @if (!sharedSvc.isMobileMode()) {
      <span class="icon-text" translate>User Login</span>
    } @else {
      <span class="icon-text title" translate>Login</span>
    }
  </a>
</div>
